import { defineStore } from 'pinia';
import { api, type AdminInfo } from '../lib/api';

interface State {
  admin: AdminInfo | null;
  ready: boolean;
}

export const useAuth = defineStore('auth', {
  state: (): State => ({ admin: null, ready: false }),
  getters: {
    isAuthenticated: (s) => !!s.admin,
  },
  actions: {
    async login(email: string, password: string) {
      const out = await api.login(email, password);
      this.admin = out.admin;
    },
    async hydrate() {
      if (!api.hasToken()) {
        this.ready = true;
        return;
      }
      try {
        this.admin = await api.me();
      } catch {
        api.clearTokens();
        this.admin = null;
      } finally {
        this.ready = true;
      }
    },
    async logout() {
      await api.logout();
      this.admin = null;
    },
  },
});
